import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TemplateSection } from 'src/app/core/models';

@Component({
  selector: 'app-section-tabs',
  templateUrl: './section-tabs.component.html',
  styleUrls: ['./section-tabs.component.scss']
})
export class SectionTabsComponent {
  private _sections: TemplateSection[] = [];

  @Input()
  set sections(value: TemplateSection[] | null | undefined) {
    this._sections = value ?? [];
  }
  get sections(): TemplateSection[] {
    return this._sections;
  }

  @Input() activeIndex = 0;
  @Output() activeIndexChange = new EventEmitter<number>();

  select(index: number): void {
    this.activeIndexChange.emit(index);
  }
}
